var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellPetrieDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 111.45,
    cy: 109.68,
    r: 77.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 88.12,
    cy: 86.34,
    r: 31.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 145.07,
    cy: 144.3,
    r: 14.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 91.92,
    cy: 153.06,
    rx: 8.48,
    ry: 32.56,
    transform: "translate(-85.69 171.28) rotate(-64.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.33,
    cy: 62.06,
    r: 8.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 137.61,
    cy: 109.42,
    r: 8.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 86,
    cy: 76.39,
    r: 8.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPetrieDish);
export default __webpack_public_path__ + "static/media/CELL_PETRIE_DISH.16ae02ce74d8e98734f05254f269add2.svg";
export { ForwardRef as ReactComponent };